// extracted by mini-css-extract-plugin
export default {"resume_container":"Resume_resume_container__agsdS","download":"Resume_download__c0cJ6","close":"Resume_close__P+VeK"};